import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-cake-build-variants',
  templateUrl: './ui-cake-build-variants.component.html'
})
export class UiCakeBuildVariantsComponent {
  @Input() disabled: boolean;
  @Input() isPieces: boolean;
  @Input() variants: any[];
  @Input() activeVariant: any;
  @Input() currency = 'kr';
  @Input() discount: number;

  @Output() onSelect = new EventEmitter<any>();
}
